"use client"
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

function ScrollHandler() {
  const pathname = usePathname()

  useEffect(() => {
    const noScrollPages = '/edit';
    if (typeof window === "undefined") return
    const root = document.documentElement
    const body = document.body

    if (pathname.includes(noScrollPages)) {
      root.style.overflowY = 'hidden'
      body.style.overflowY = 'hidden'
    } else {
      root.style.overflowY = 'auto'
      body.style.overflowY = 'visible'
    }
    return () => {
      root.style.overflowY = "auto";
      body.style.overflowY = "visible";
    };
  }, [pathname])
  return (
    null
  )
}

export default ScrollHandler
